import { FlipRotateState } from "../types";

interface Payload {
    payload: boolean;
}

export const setIsLoading = (state: FlipRotateState, { payload: value }: Payload) => {
    state.isLoading = value;
};
